import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findShipmentList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/list2?` + params,
        method: 'GET'
    })
}
export const findShipmentListExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/shipmentExcel?` + params,
        method: 'GET'
    })
}
export const findProductGoodsList = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/product/all`,
        method: 'GET'
    })
}
export const v2ProductSelect = () => {
    return request({
        url: `${baseUrl}/joins-product/v2/product/select`,
        method: 'GET'
    })
}

export const addShipment = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/addShipment`,
        method: 'POST',
        data: data
    })
}

export const addShipment2 = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/addShipment2`,
        method: 'POST',
        data: data
    })
}
export const findShipmentById = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/shipmentDetail/${id}`,
        method: 'GET'
    })
}
export const updateShipment = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/updateShipment`,
        method: 'PUT',
        data: data
    })
}
export const send = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/send/${id}`,
        method: 'GET'
    })
}

export const engineerGoodsSelect = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_goods/select?`+params,
        method: 'GET'
    })
}

export const addEngineerShipment = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/addEngineerShipment`,
        method: 'POST',
        data: data
    })
}
